import React from 'react';
import {
  Box,
  Flex,
  useBreakpointValue,
} from '@chakra-ui/react';
import { Suspense, lazy, useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from '../NavBar/NavBar';
import { Sidebar } from '../NavBar/Sidebar';
import { TopNav } from '../TopNav/TopNav';
import { Rewards } from '../Rewards/Rewards';
import { LoadingIcon } from '../Icons/Icons';

const NoPageMatch = lazy(() => import('../NoPageMatch/NoPageMatch'));
const InProgress = lazy(() => import('../InProgress/InProgress'));
// const Verify = lazy(() => import('../Verify/Verify'));
const Swap = lazy(() => import('../Swap/Swap'));

const Dashboard = () => {
  const isDesktop = useBreakpointValue({base: false, lg: true, });

  return (
    <BrowserRouter>
      <ScrollToTop>
        <Flex as="section" direction={{ base: 'column', lg: 'row', }} height="100vh" overflow="hidden" >
          {isDesktop ? <Sidebar /> : <Navbar />}
          <Box bgImage="images/background.png" bgPos="center" bgRepeat="no-repeat" bgSize='cover' overflowY="auto" flex="1">
            {isDesktop ? <TopNav /> : null}
            <Box maxW={"8xl"} mx="auto" p={10}>
              <Suspense fallback={<LoadingIcon/>}> 
                <Routes>
                  <Route path="/" element={<Rewards />}/>
                  <Route path="/rewards" element={<Rewards />}/>
                  <Route path="/stake" element={<InProgress />}/>
                  <Route path="/swap" element={<Swap />}/>
                  {/* <Route path="/avs" element={<Verify />}/> */}
                  <Route path="*" element={<NoPageMatch/>}/>
                </Routes>
              </Suspense>
            </Box>
          </Box>
        </Flex>
      </ScrollToTop>
    </BrowserRouter>
  );
}

const ScrollToTop = ({children}) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children
} 

export default Dashboard;
